export default __webpack_public_path__ + "static/media/Illustration.caf9ae27.png";